import axios, { AxiosPromise } from 'axios';

import { CadastroImobiliario, EnglobamentoItbi } from '../type';

export const findCadastroFormSelect = (params: {}) =>
  axios.get('/api/imoveis', { params });

export const findCadastroImobiliario = (codigo: string): AxiosPromise<any> =>
  axios.get(`/api/imoveis/${codigo}`);

export const resolverEnglobamento = (
  codigo: number
): AxiosPromise<EnglobamentoItbi> =>
  axios.get(`/api/imoveis/${codigo}/englobamento`);

export const findByInscricaoCadastral = (
  inscricaoCadastral: string
): AxiosPromise<any> =>
  axios.get(`/api/imoveis/${inscricaoCadastral}/inscricao-cadastral`);

export const findByCadastroComValorAvaliado = (
  cadastro: string
): AxiosPromise<CadastroImobiliario> =>
  axios.get(`/api/imoveis/${cadastro}/calcular-valores-avaliacao`);
